import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

/** 参加用 URL の QR コードをクライアント側で生成する（要件1.2）。 */
export function useQrCode(text: string, size = 320): string | null {
  const [dataUrl, setDataUrl] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    void QRCode.toDataURL(text, {
      width: size,
      margin: 1,
      errorCorrectionLevel: 'M',
      color: { dark: '#0f172a', light: '#ffffff' },
    })
      .then((url) => {
        if (!cancelled) setDataUrl(url);
      })
      .catch(() => {
        if (!cancelled) setDataUrl(null);
      });
    return () => {
      cancelled = true;
    };
  }, [text, size]);

  return dataUrl;
}
